import {useState, useEffect} from 'react';
import {monitorAction} from '../../../../../services/datadog';

export const useBPMHeaderPortalContainer = () => {
    /*
     * Hook to get the BPM header portal container, this hook is used as a fix for Jira ticket: EP-46521 - a bug that causes the BPM header to not render.
     */
    const [portalHeaderContainer, setPortalHeaderContainer] = useState(null);

    useEffect(() => {
        const findPortal = () => document.getElementById('bpm-header-portal');

        let container = findPortal();
        if (container) {
            setPortalHeaderContainer(container);
            return () => {};
        }

        let attempts = 0;
        const intervalId = setInterval(() => {
            container = findPortal();
            if (container) {
                setPortalHeaderContainer(container);
                clearInterval(intervalId);
            }
            if (++attempts >= 10) {
                clearInterval(intervalId);
                console.error("BPM header portal container wasn't found after 10 attempts");
                monitorAction('bpm-header-portal', {
                    error_description: "BPM header portal container wasn't found after 10 attempts",
                    element: 'bpm-header-portal'
                });
            }
        }, 100);

        return () => clearInterval(intervalId);
    }, []);

    return portalHeaderContainer;
};
